import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { reviewSettingDaysData } from "../../sample-data";


const initialState = {
  data: {},
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchReviewSettingDays = createAsyncThunk(
  "ReviewSettingDays/fetchReviewSettingDays",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 1000));    
    return reviewSettingDaysData;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReviewSettingDays = createSlice({
  name: "ReviewSettingDays",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewSettingDays.pending, (state) => {
        state.data = {};
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchReviewSettingDays.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchReviewSettingDays.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectReviewSettingDays = (state) => state.ReviewSettingDays.data;
export const selectIsLoading = (state) => state.ReviewSettingDays.isLoading;
export const selectError = (state) => state.ReviewSettingDays.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.ReviewSettingDays.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.ReviewSettingDays.data,
  isLoading: state.ReviewSettingDays.isLoading,
  error: state.ReviewSettingDays.error,
}));
*/
export default sliceReviewSettingDays.reducer; // Export the reducer
